<template>
  <div class="container" v-if="customEmailData">
    <br>
    <div class="col-sm-3">

      <div class="filters">
        <h5><i class="fa fa-cog" /> Filters and Preferences</h5>
        <div>
           <div class="form-location" >
                        <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="countriesListComp" name="serviceSelect" class="form-control " v-model="customEmailData.CountryId">
                                  <option value="null" disabled selected hidden>Filter specific country</option>
                                  <option value="0" >All Countries</option>
                                  <option v-for="country in countriesListComp" v-bind:value="country.CountryId">
                                    {{country.CountryName}}
                                  </option>
                                </select>
                            </div>
                        </div>
            </div>
            
             <div class="radio">
          <label class="small">
            <input type="radio" value=0 v-model="customEmailData.AudienceId">Sitters Only</label>
        </div>
        <div class="radio">
          <label class="small">
            <input type="radio" value=1 v-model="customEmailData.AudienceId">Customers Only</label>
        </div>  
        </div>
        <hr>

             <div class="radio">
          <label class="small">
            <input type="radio" :value="true" v-model="customEmailData.SendSms">Send SMS</label>
        </div>
        <div class="radio">
          <label class="small">
            <input type="radio" :value="false" v-model="customEmailData.SendSms">Dont send SMS</label>
        </div>
      </div>
      <hr>
       <label>Custom Email</label>
                <input type="text" v-model="customEmailData.CustomEmail" class="form-control " placeholder="Custom Email" />
                <br>
        <label>Custom Firstname</label>
                <input type="text" v-model="customEmailData.CustomFirstName" class="form-control " placeholder="Custom FirstName" />
        <br>
    </div>
    <div class="col-sm-9">
        <h5>Email Template, please fill in all fields</h5>
               <input type="text" v-model="customEmailData.Subject" class="form-control " placeholder="Subject (Email Subject)" />
                    
                <br>
                <input type="text" v-model="customEmailData.CustomHeader" class="form-control " placeholder="Custom Header <p>" />
                <br>
                <input type="text" v-model="customEmailData.MainMessage" class="form-control " placeholder="Main Message <h1>" />
                <br>
                <textarea class="form-control" rows="3" v-if="customEmailData.SendSms"  placeholder="SMS Message"  v-model="customEmailData.MessageSms"></textarea>
                <br v-if="customEmailData.SendSms">
                <textarea class="form-control" rows="3"  placeholder="Sub Message <h4>"  v-model="customEmailData.SubMessage"></textarea>
                <br>
                <input type="text" v-model="customEmailData.ButtonTitle" class="form-control " placeholder="Button Title" />
                <br>
                <input type="text" v-model="customEmailData.ButtonLink" class="form-control " placeholder="Button Link (Url format https://xxxx.com)" />
                
                <hr>
                <button @click="sendCustomEmail()" :disabled="sent" class="btn btn-lg btn-warning btn-block">Send Email</button>
    </div>
    
    </div>
    
  </div>
</template>


<script>
  import auth from '../../auth/index'
  import store from '../../data/store'
  import commonApi from '../../services/commonApi'
  import customerApi from '../../services/customerApi'


  export default {
    data() {
      return {
        sent: false,
        error: '',
        customEmailData: null,
        alert: '',
        emailConfirmed: true,
        title: "Dupaws admin control",
        pending: true
      }
    },
    updated: function () {
      $('[data-toggle="popover"]').popover();

      // $zopim(function () {
      //   $zopim.livechat.hideAll();

      // });


      if (this.userRoleComp != "Admin") {
        this.$router.push({
          path: '/404'
        })
        return;
      }
    },
    mounted: function () {
      var self = this
      this.initCustomEmailData()
      
      // $zopim(function () {
      //   $zopim.livechat.hideAll();

      // });
      
     
    },
    methods: {
      sendCustomEmail: function () {
        var self = this
        self.sent=false
        $.ajax("https://www.dupaws.com/services/api/admin/sendCustomEmail/", {
          type: 'POST',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
          },
          data: JSON.stringify(self.customEmailData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          crossDomain: true,
          success: function (data) {
            swal("Success", "The emails has been successfully sent", "success")
          },
          error: function (error) {
            swal("Error", "The emails couldn't be sent!", "error")
          }
        });

      },
      initCustomEmailData: function () {
        var self = this
        $.ajax("https://www.dupaws.com/services/api/admin/initCustomEmailData/", {
          type: 'GET',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
          },
          data: JSON.stringify(self.query),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          crossDomain: true,
          success: function (data) {
            self.customEmailData=data
          },
          error: function (error) {

          }
        });

      },


    },
    head: {
      // To use "this" in the component, it is necessary to return the object through a function
      title: function () {
        return {
          inner: this.title
        }
      }
    },
    computed: {
      countriesListComp: function () {
        return store.getters.CountriesList
      },
      errorMsg: function () {
        return this.error
      },
      alertMsg: function () {
        return this.alert
      },
      userRoleComp: function () {
        return store.getters.userRole
      }


    }

  }

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// CustomEmail.vue?5dcb2d26